module.exports = __webpack_public_path__ + "static/media/slide3Inactive.2bee620a.png";